import { createApp } from './vue';

import advertisement from './vue/apps/advertisement';

const advertisementMountingContainer = document.querySelectorAll('.js-ads-container');

if (advertisementMountingContainer) {
    const ads = [];

    advertisementMountingContainer.forEach((el) => {
        const app = createApp(advertisement).mount(el);
        ads.push(app);
    });
}
